import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'
import { GroupVisibility } from 'app/types/GroupVisibility'

const query = gql`
  query searchGroups(
    $searchTerm: String
    $limit: Int
    $sort: String
    $page: Int
    $categories: [String!]
  ) {
    searchGroups(
      searchTerm: $searchTerm
      limit: $limit
      sort: $sort
      page: $page
      categories: $categories
    ) {
      totalDocs
      page
      docs {
        id
        name
        totalMembers
        visibility
        profileImage {
          id
          sizes {
            small {
              url
            }
            medium {
              url
            }
          }
        }
        university {
          slug
        }
        universityCourse {
          slug
        }
        allowedUserTypes
      }
    }
  }
`

export enum SearchGroupsSort {
  NameAsc = 'name',
  NameDesc = '-name',
  MembersAsc = 'members',
  MembersDesc = '-members',
  DateAsc = 'date',
  DateDesc = '-date',
}

export interface SearchGroupsQueryInput {
  page: number
  limit: number
  sort: string
  searchTerm?: string
  categories?: string[]
}

export interface SearchGroupsQueryOutput {
  searchGroups: {
    totalDocs: number
    page: number
    totalPages: number
    docs: {
      id: string
      name: string
      visibility: GroupVisibility
      totalMembers: number
      profileImage: {
        sizes: {
          small: {
            url: string
          }
          medium: {
            url: string
          }
        }
      }
      university?: {
        slug: string
      }
      universityCourse?: {
        slug: string
      }
      allowedUserTypes: string[]
    }[]
  }
}

const defaultVariables: SearchGroupsQueryInput = {
  page: 1,
  limit: 10,
  sort: SearchGroupsSort.NameAsc,
  searchTerm: '',
  categories: [],
}

export const useSearchGroupsQuery = (
  options: QueryHookOptions<SearchGroupsQueryOutput, SearchGroupsQueryInput>
) => usePersistedCacheQuery<SearchGroupsQueryOutput, SearchGroupsQueryInput>(query, options)

export const searchGroupsQuery = {
  query,
  defaultVariables,
}
